/**
 * Copyright (c) 2020 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import Loading from '../../components/loading/loading.component';
import PropTypes from 'prop-types';
import * as consts from '../../const.js';
import { ControlLabel, Form, FormControl, FormGroup, Grid, Row } from 'react-bootstrap';
import { Button } from 'tc-client-common';
import Notification from '../common/notification/notification.component';
import DatePicker from 'react-bootstrap-date-picker-react16';
import DateUtils from '../../helper/date';

class ParticipantBirthdateComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      birthdate: this.props.currentBirthdate,
      reason: '',
      updateError: null
    };
  }

  handleParticipantBirthdateChange = (selectedISODate) => {
    const utcDateSameDay = DateUtils.removeOffsetTime(new Date(selectedISODate));
    const birthdateTimestamp = DateUtils.getUtcMiddayTime(utcDateSameDay);

    if (birthdateTimestamp - this.getMaxBirthdateTimestamp() > 0) {
      this.setState(() => ({ updateError: consts.PARTICIPANT_BIRTHDATE_UPDATE_ERROR }));
    } else {
      this.setState(() => ({ birthdate: birthdateTimestamp, updateError: null }));
    }
  };

  getMaxBirthdateTimestamp() {
    const endOfToday = DateUtils.getEndOfTodayTimestamp();
    const maxPossibleOffset = -(14 * 60 * 60 * 1000);

    return endOfToday - maxPossibleOffset;
  }

  changeReasonHandler = (event) => {
    const value = event.target.value;
    this.setState(() => ({ reason: value }));
  };

  updateParticipantBirthdate = (e) => {
    e.preventDefault();
    const { birthdate, reason } = this.state;
    const { updateParticipantBirthdate, participantId } = this.props;
    const payload = { birthdate, reason };
    updateParticipantBirthdate(participantId, payload);
  };

  render() {
    const { isLoading, error } = this.props;
    const { birthdate, updateError } = this.state;
    let errorBody = '';
    if (error || updateError) {
      errorBody = error ? (
        <Row>
          <Notification type="error" data={error} />
        </Row>
      ) : (
        <Row>
          <Notification type="error" data={updateError} />
        </Row>
      );
    }
    const birthdateISOString = DateUtils.addOffsetTime(birthdate - 1000);
    const todayISOString = new Date().toISOString();

    return (
      <Form horizontal id="edit-participant-birthdate-form" onSubmit={this.updateParticipantBirthdate}>
        <Grid id="edit-participant-birthdate-grid" fluid>
          {errorBody}
          <Row>
            <FormGroup controlId="participant-birthdate-input">
              <ControlLabel>{consts.SELECT_PARTICIPANT_BIRTHDATE}</ControlLabel>
              <DatePicker
                showClearButton={false}
                onChange={this.handleParticipantBirthdateChange}
                required
                value={birthdateISOString}
                maxDate={todayISOString}
                disabled={isLoading}
              />
            </FormGroup>
            <FormGroup controlId="reason">
              <ControlLabel>
                {consts.CHANGE_PARTICIPANT_BIRTHDATE_REASON}
                <span> *</span>
              </ControlLabel>
              <FormControl
                componentClass="textarea"
                value={this.state.reason}
                onChange={this.changeReasonHandler}
                required
                disabled={isLoading}
              />
            </FormGroup>
          </Row>
        </Grid>
        <div className="edit-modal-footer">
          <hr className="edit-modal-divider" />
          <Button
            id="edit-participant-birthdate-cancel-button"
            theme="default large-button"
            type="reset"
            disabled={isLoading}
            handleClick={() => {
              this.props.hide();
            }}
            label={consts.CANCEL_BTN}
          />
          <Button
            id="edit-participant-birthdate-save-button"
            theme="active large-button"
            type="submit"
            disabled={isLoading || this.state.reason.trim() === ''}
            label={consts.SAVE_BTN}
          >
            {isLoading ? <Loading /> : null}
          </Button>
        </div>
      </Form>
    );
  }
}

ParticipantBirthdateComponent.propTypes = {
  error: PropTypes.object,
  isLoading: PropTypes.bool,
  currentBirthdate: PropTypes.number.isRequired,
  participantId: PropTypes.number.isRequired,
  updateParticipantBirthdate: PropTypes.func,
  hide: PropTypes.func
};

export default ParticipantBirthdateComponent;
